import { FabriqNativeLoader } from "@/classes/FabriqNativeLoader";

const loader = new FabriqNativeLoader("");
export default loader;
